import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { AdministrationService } from 'src/app/services/administration/administration.service';
import * as moment from 'moment'


@Component({
  selector: 'app-school-news',
  templateUrl: './school-news.component.html',
  styleUrls: ['./school-news.component.css']
})
export class SchoolNewsComponent implements OnInit {


  FacilityList: any;
  Submitted: boolean = false;
  AlbumPhoto: string[] = [];
  SchoolNewsImageList: any;
  PhotoList:any;
  SchoolNewsList:any;
  

  constructor(private adminservice: AdministrationService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  NewsModel = {
    SchoolNewsID: 0,
            SchoolNews: '',
            IsActive:true,
            NewsDescription:''
           
  };

  Clear() {

    this.NewsModel.SchoolNewsID = 0;
    this.NewsModel.SchoolNews = '';
    this.NewsModel.NewsDescription='';
  };


  GetAllSchoolNews() {
    this.spinnerService.show();
    this.adminservice.GetAllSchoolNews().subscribe((response: any) => {
      this.SchoolNewsList = response.SchoolNewsList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
    });
  };


  SaveSchoolNews(valid) {
    this.Submitted = true;
    if (valid) {
      this.spinnerService.show();
      this.adminservice.SaveSchoolNews(this.NewsModel.SchoolNewsID,this.NewsModel.SchoolNews,this.NewsModel.NewsDescription).subscribe((data: any) => {
        this.Submitted = false;
        if (data.webResponse.Status && this.NewsModel.SchoolNewsID == 0) {
          this.Clear();
        }
        this.GetAllSchoolNews();
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);

      });
    }

  }

  Edit(obj) {
    this.NewsModel.SchoolNewsID = obj.SchoolNewsID;
    this.NewsModel.SchoolNews = obj.SchoolNews;
    this.NewsModel.NewsDescription = obj.NewsDescription;
  };


  SchoolNewsMarkActive(obj) {
    this.Clear();
    this.NewsModel.SchoolNewsID = obj.SchoolNewsID;
    this.NewsModel.IsActive = obj.IsActive == true ? false : true;
    this.spinnerService.show();
    this.adminservice.SchoolNewsMarkActive(JSON.stringify(this.NewsModel)).subscribe((response: any) => {
      this.spinnerService.hide();
      this.GetAllSchoolNews();
      this.globalHelper.CheckActionStatus(response);

    });
  }


  ngOnInit() {
    this.GetAllSchoolNews();
    
  }


  // Upload Facilty Images

  UploadModel = {
    FacilityID: 0,
    FacilityName: '',
    SchoolNews:'',
  }

  Upload(item) {
    this.UploadModel.FacilityID = item.FacilityID;
    this.UploadModel.FacilityName = item.FacilityName;
    this.GetAllSchoolNewsImage();
  }



  GetAllSchoolNewsImage() {
    this.spinnerService.show();
    this.adminservice.GetAllSchoolNewsImage(JSON.stringify(this.UploadModel)).subscribe((response: any) => {
      this.SchoolNewsImageList = response.SchoolNewsImageList;
      this.spinnerService.hide();
    });
  };


  getFileDetails(e) {
    this.AlbumPhoto = [];
    for (var i = 0; i < e.target.files.length; i++) {
      this.AlbumPhoto.push(e.target.files[i])
    }
  }


  SaveSchoolNewsImage() {
    this.spinnerService.show();
    this.adminservice.SaveSchoolNewsImage(JSON.stringify(this.UploadModel), this.AlbumPhoto).subscribe((data: any) => {
      this.spinnerService.hide();
      this.GetAllSchoolNewsImage();
      this.globalHelper.CheckActionStatus(data);

    });
  };

  
  Delete() {
      this.PhotoList = [];
      for (var j = 0; j < this.SchoolNewsImageList.length; j++) {
         
          if (this.SchoolNewsImageList[j].IsSelect == true) {
                  var model = {
                      PhotoID: this.SchoolNewsImageList[j].NewsImageID
                  }
                  this.PhotoList.push(model);
              }
          
      }

      this.spinnerService.show();
      this.adminservice.DeleteSchoolNewsImage(JSON.stringify(this.PhotoList)).subscribe((data: any) => {
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
          this.GetAllSchoolNewsImage();
      });
  }


}







